import _get from "lodash/get";

import { formatDateInTimezone } from "../../../../../../utils/timezoneUtils";

export const EMPTY = "—";

export const VENDOR_INSTRUCTIONS =
  "Complete all requested information before returning";

const formatDate = (value, timezone) =>
  formatDateInTimezone(value, timezone) || EMPTY;

const getRfqNumber = bidGroup => {
  const projectNumber = _get(bidGroup, "project.number");
  const sequenceIndex = _get(bidGroup, "sequenceIndex");

  if (projectNumber == null || sequenceIndex == null) {
    return EMPTY;
  }

  return `${projectNumber}-${String(sequenceIndex).padStart(3, "0")}`;
};

const getSpecifier = bidGroup => {
  const designer = _get(bidGroup, "project.designer");

  if (!designer || !designer.name) {
    return EMPTY;
  }

  const city = _get(designer, "location.city");
  const state = _get(designer, "location.state");

  if (city && state) {
    return `${designer.name} - ${city}, ${state}`;
  }

  return designer.name;
};

export const getRfqInfo = (bidGroupVendor, timezone) => {
  const bidGroup = _get(bidGroupVendor, "bidGroup");

  return {
    rfqNumber: getRfqNumber(bidGroup),
    issueDate: formatDate(_get(bidGroup, "rfq.issuedDate"), timezone),
    formDueDate: formatDate(_get(bidGroup, "rfq.responseDate"), timezone),
    requiredShipDate: formatDate(_get(bidGroupVendor, "shipDate"), timezone),
    specifier: getSpecifier(bidGroup),
    vendorInstructions: VENDOR_INSTRUCTIONS,
  };
};
